// extracted by mini-css-extract-plugin
export default {"navigate":"BradCrumbs_navigate__lHYEH"};